import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import {PageGetIp, EPageActions, PageGetIpSuccess, PageReminderBets, PageReminderBetsSuccess} from '../actions/page.actions';
import {concatMap, distinctUntilChanged, switchMap} from 'rxjs/operators';
import { IpService } from 'src/app/service/http/ip/ip.service';
import { of } from 'rxjs';
import {TicketsService} from '../../service/ticket/tickets.service';
import {IPlayremainders} from '../../models/playremainders.interface';

@Injectable()
export class PageEffects {
  
  getPage$ = createEffect(() => this._actions$.pipe(
    ofType<PageGetIp>(EPageActions.PageGetIp),
    switchMap(() => this._ipService.getIp()),
    switchMap((ip: any) => {
      return of(new PageGetIpSuccess(ip));
    })
  ));

  
  getReminder$ = createEffect(() => this._actions$.pipe(
    ofType<PageReminderBets>(EPageActions.PageReminderBets),
    concatMap((action) => this._ticketService.getPlayReminders(action.session, action.race, action.events)),
    distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
    concatMap((rasponse: any) => {
      return of(new PageReminderBetsSuccess(rasponse.playload, rasponse.events));
    })
  ));

  constructor(
    private _ipService: IpService,
    private _ticketService: TicketsService,
    private _actions$: Actions) {}
}

